import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Size } from './common';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  private screenWidthChange = new BehaviorSubject<Size>(Size.MONITOR);

  public readonly screenWidthChange$ = this.screenWidthChange.asObservable();

  changeScreen(screenType: Size) {
    this.screenWidthChange.next(screenType);
  }
}
